export const SKU_SEARCH_PARAMS = Object.freeze({
  SKU_ID: "skuId",
  SKU_COMMERCIAL_NAME: "skuCommercialName",
  IS_OFFICIAL_IMAGE: "hasOfficialImage",
});
